import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { InsideSection } from '../components/sales/InsideSection';
import { PainSection } from '../components/sales/PainSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { VolumesSection } from '../components/sales/VolumesSection';
import { BonusesSection } from '../components/sales/BonusesSection';
import { BeforeAfterSection } from '../components/sales/BeforeAfterSection';
import { AudienceSection } from '../components/sales/AudienceSection';
import { OfferSection } from '../components/sales/OfferSection';
import { FaqSection } from '../components/sales/FaqSection';
import { FinalSection } from '../components/sales/FinalSection';
import { SiteFooter } from '../components/sales/SiteFooter';
export function SalesPage() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-brand-ivory font-body text-brand-charcoal" data-id="element-186" data-mp="3qprnmsngzk0w">
      <header className="border-b border-brand-charcoal/10 bg-brand-paper" data-id="element-187" data-mp="3vntfo32vitoi">
        <div className="mx-auto flex max-w-6xl items-center justify-center px-5 py-3 lg:px-8" data-id="element-188" data-mp="3akrthls6620o">
          <p className="font-body text-[11px] font-semibold uppercase tracking-[0.22em] text-brand-charcoal" data-id="element-189" data-mp="35rypx18fszq6">
            Hair Instructor Ready™ · Édition Française
          </p>
        </div>
      </header>

      <main data-id="element-190" data-mp="2vw556ukkdzxb">
        <HeroSection data-id="element-191" data-mp="2vweyos4tip7r" />
        <InsideSection data-id="element-192" data-mp="2vszfpe80ww12" />
        <PainSection data-id="element-193" data-mp="3tic9e3cyhq95" />
        <SolutionSection data-id="element-194" data-mp="3thjb7qs2c92m" />
        <VolumesSection data-id="element-195" data-mp="3ti2kyk7k7r5k" />
        <BonusesSection data-id="element-196" data-mp="3tg87fqymb1bi" />
        <BeforeAfterSection data-id="element-197" data-mp="3oizp9qdgyxa9" />
        <AudienceSection data-id="element-198" data-mp="3oksv53g9ddh7" />
        <OfferSection data-id="element-199" data-mp="3ohesdu3on298" />
        <FaqSection data-id="element-200" data-mp="3jkeljgz0dvh2" />
        <FinalSection data-id="element-201" data-mp="3jjn2f5mllq7o" />
      </main>

      <SiteFooter data-id="element-202" data-mp="3jituw2ftewoh" />
    </div>;
}